import { render } from "./shcarousel-skeleton.vue?vue&type=template&id=5af8804e&scoped=true"
import script from "./shcarousel-skeleton.vue?vue&type=script&lang=js"
export * from "./shcarousel-skeleton.vue?vue&type=script&lang=js"

import "./shcarousel-skeleton.vue?vue&type=style&index=0&id=5af8804e&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af8804e"]])

export default __exports__